import { render } from "./TrainVue.vue?vue&type=template&id=04aad6fc&scoped=true"
import script from "./TrainVue.vue?vue&type=script&lang=js"
export * from "./TrainVue.vue?vue&type=script&lang=js"

import "./TrainVue.vue?vue&type=style&index=0&id=04aad6fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04aad6fc"]])

export default __exports__